export default __webpack_public_path__ + "static/media/storm-share.b4d6c198.png";